import { Steps } from 'antd';
import styled from 'styled-components';

export default styled(Steps)`
	// Add your styles here
`;
